import React, { useState } from 'react';
import Startquiz from './Startquiz';
import Msquiz from './Msquiz';
import Dtpquiz from './Dtpquiz';
import Clangquiz from './Clangquiz';

const QuizContainer = () => {

  const [studentName, setStudentName] = useState('');
  const [email, setEmail] = useState('');
  const [quizId, setQuidId] = useState('');
  const [quizStarted, setQuizStarted] = useState(false);

  const handleStartQuiz = (name) => {
    setStudentName(name);
    setQuizStarted(true);
    // console.log('container',name);
  };
  const getId = (id) => {
    setQuidId(id);
    // console.log('id',id);
  }
  const getEmailId = (gmail) => {
    setEmail(gmail);
    // console.log('gmail',gmail);
  }

  return (
    <div>
      {!quizStarted && !!handleStartQuiz? (
        <Startquiz studentId={handleStartQuiz} emailId={getEmailId} quizId={getId}/>
      ) : quizId === 'msOffice' ? (
        <Msquiz stuName={studentName} getEmailId={email} getQuizId={quizId}/>
      ) : quizId === 'dtp' ? (
        <Dtpquiz stuName={studentName} getEmailId={email} getQuizId={quizId}/>
      ): quizId === 'cLanguage' ? (
      <Clangquiz stuName={studentName} getEmailId={email} getQuizId={quizId}/>
      ) : (
        <div>No Quiz Selected</div>
      )}
    </div>
  );
};

export default QuizContainer;
